import {
  Component,
  HostListener,
  DoCheck,
  OnInit,
  ViewChild,
  Renderer2,
  ElementRef,
} from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { HeadService } from './@shared/services/head.service';
import { HeaderComponent } from './@shared/header/header.component';
import { HttpClient } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, distinctUntilChanged, catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AuthService } from './@auth/auth-material/auth.service';

const databaseKey: string = environment.servralUrl;

const routes = {
  auth: {
    login: () => `${databaseKey}/api/auth/signin`,
    getAllAccess_menu: (res: any) =>
      `${databaseKey}/api/v1/getroleMenuAccessdetails?employee_id=${res?.employee_id}&role_master_id=${res?.role_master_id}&entity_id=${res?.entity_id}`,
    create_Attendance: () => `${databaseKey}/api/v1/create_Attendance`,
    screenMode: () => `${databaseKey}/api/v1/create_Screen_On_Off`,
    getAssignAction: (res: any) =>
      `${databaseKey}/api/v1/getassignactionfucntion?employee_id=${res?.employee_id}&role_master_id=${res?.role_master_id}&entity_id=${res?.entity_id}`,
  },
};

interface ModuleAction {
  Read: boolean;
  Write: boolean;
  Delete: boolean;
}

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, DoCheck {
  title:string=""
  @ViewChild('header', { static: true }) header!: HeaderComponent;

  isLoggedIn$!: Observable<boolean>;
  local: ModuleAction = { Read: false, Write: false, Delete: false };

  currentRoute: string;
  activeSubmenuId: number | null = null;

  // guard to avoid calling API multiple times for same submenu
  private lastSubmenuId: number | null = null;

  constructor(
    private head: HeadService,
    private router: Router,
    private renderer: Renderer2,
    private el: ElementRef,
    private http: HttpClient,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // single place where we react to route changes (including back/forward, direct URL)
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event: NavigationEnd) => event.urlAfterRedirects || event.url),
        distinctUntilChanged() // same URL won't fire twice
      )
      .subscribe((url) => {
        this.currentRoute = url;
        // 
        this.findSubmenuAndSetPermissions(this.currentRoute);
      });
  }

  private findSubmenuAndSetPermissions(currentRoute: string): void {
    const userPermissionsStr = localStorage.getItem('userPermissions');
    if (!userPermissionsStr) return;

    let parsedPermissions: unknown;
    try {
      parsedPermissions = JSON.parse(userPermissionsStr);
    } catch {
      return;
    }

    const userPermissions = Array.isArray(parsedPermissions)
      ? parsedPermissions
      : Array.isArray((parsedPermissions as { data?: unknown })?.data)
        ? (parsedPermissions as { data: unknown[] }).data
        : [];

    if (!userPermissions.length) return;

    // get last path segment (after /master/.../)
    const lastRouteSegment = currentRoute
      .split('?')[0]
      .split('#')[0]
      .split('/')
      .filter(Boolean)
      .pop()
      ?.trim()
      .toLowerCase();

    if (!lastRouteSegment) return;

    // 

    const employeeId = localStorage.getItem('EmpMainId') || '';
    const roleMasterId = localStorage.getItem('role_master_id') || '';
    const entityId = localStorage.getItem('selectedEntityId') || '';

    const res = {
      employee_id: employeeId,
      role_master_id: roleMasterId,
      entity_id: entityId,
    };

    // flatten all submenus
    const allSubmenus = userPermissions.flatMap((module: any) =>
      (module.HRMS_RBAC_MENU_MASTER || []).flatMap((menu: any) =>
        (menu.HRMS_RBAC_SUBMENU_MASTER || []).map((submenu: any) => ({
          submenu,
          menu,
          module,
        }))
      )
    );

    const matched = allSubmenus.find((entry: any) =>
      entry.submenu.submenu_masters_link?.trim().toLowerCase() === lastRouteSegment
    );

    // 

    if (!matched) {
      // console.warn(`No matching submenu found for route segment: ${lastRouteSegment}`);
      return;
    }

    const { submenu, menu, module } = matched;

    // IF we already processed this submenu, do nothing
    if (this.lastSubmenuId === submenu.submenu_master_id) {
      return;
    }
    this.lastSubmenuId = submenu.submenu_master_id;
    this.activeSubmenuId = submenu.submenu_master_id;

    const permissionRequest = {
      role_module_master_id: module.role_module_master_id,
      menu_master_id: menu.menu_master_id,
      submenu_master_id: submenu.submenu_master_id,
    };

    this.authService
      .getModuleActions(res, permissionRequest)
      .subscribe((permissions: any) => {
        
        // here you can also put it into localStorage if needed
        // localStorage.setItem('local', JSON.stringify(permissions?.data?.options ?? {}));
      });
  }

  ngDoCheck(): void {}

  onClick(event: any) {
    this.renderer.addClass(this.el.nativeElement, 'highlight');
  }

  @HostListener('window:click', ['$event'])
  onWindowClick(event: Event): void {
    this.onClick(event);
  }

  // you can delete this method if no one uses it anymore
  getModuleActions(res: any, module: any): Promise<any> {
    const fallbackPermissions: any = {
      Read: false,
      Write: false,
      Delete: false,
    };

    const body = {
      role_module_master_id: module.role_module_master_id,
      menu_master_id: module.menu_master_id,
      submenu_master_id: module.submenu_master_id,
    };

    return this.http
      .post<any>(routes.auth.getAssignAction(res), body)
      .pipe(
        tap((response) => {
          if (response?.data?.options) {
            this.local = response.data.options;
            localStorage.setItem('local', JSON.stringify(response.data.options));
          } else {
            throw new Error('Invalid permissions data');
          }
        }),
        catchError((error) => {
          console.error('getModuleActions error:', error);
          this.local = fallbackPermissions;
          localStorage.setItem('local', JSON.stringify(fallbackPermissions));
          return of(fallbackPermissions);
        })
      )
      .toPromise();
  }
}
